/**
 * Утиліти перевірки відповідності типу push-сповіщення та вмісту тіла.
 * Використовується у формах одиничних і масових сповіщень.
 *
 * detectNotificationType(text) — визначає тип за наявністю HTML-тегів у тексті.
 *   Повертає 'html' якщо теги знайдено, інакше 'text'.
 *
 * isTypeMismatch(selectedType, bodyText) — порівнює обраний тип з виявленим.
 *   Повертає true якщо є невідповідність (потрібно показати модалку підтвердження).
 *
 * Приклади невідповідності:
 *   selectedType='text', bodyText містить <b> → true
 *   selectedType='html', bodyText без тегів   → true
 */

const HTML_TAG_REGEX = /<[a-z][\s\S]*?>/i;

export const detectNotificationType = (text) =>
	HTML_TAG_REGEX.test(text) ? 'html' : 'text';

export const isTypeMismatch = (selectedType, bodyText) =>
	selectedType !== detectNotificationType(bodyText);
